import * as React from "react";
import type { SVGProps } from "react";
const SvgHeartOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.05 4.24c1.268 0 2.362.613 3.11 1.182.348.265.633.529.84.737.207-.208.492-.472.84-.737.748-.569 1.842-1.182 3.11-1.182h.01a4.79 4.79 0 0 1 3.618 7.815c-.292.362-1.94 2.055-3.479 3.622a958 958 0 0 1-2.787 2.826l-.253.255-.002.002v.001h-.002a1.5 1.5 0 0 1-1.048.449h-.01a1.5 1.5 0 0 1-1.064-.45l-.002-.002-.252-.254a788 788 0 0 1-2.783-2.816c-.777-.79-1.571-1.604-2.206-2.264-.616-.64-1.11-1.166-1.271-1.373a4.79 4.79 0 0 1 3.621-7.81zm3.24 14.17.354-.353.003.003a.5.5 0 0 0 .35.15.5.5 0 0 0 .346-.15l.002-.002.354.35-.354-.35.256-.259a1082 1082 0 0 0 2.785-2.823c1.57-1.6 3.165-3.24 3.415-3.55l.002-.002a3.79 3.79 0 0 0-2.858-6.184c-.95.002-1.83.468-2.5.978a7 7 0 0 0-1.041.978l-.012.014-.002.003a.5.5 0 0 1-.78 0l-.002-.003-.012-.014-.051-.06a7.099 7.099 0 0 0-.99-.918c-.67-.51-1.55-.976-2.5-.978a3.79 3.79 0 0 0-2.857 6.184l.008.01c.114.148.561.628 1.205 1.297.63.656 1.422 1.467 2.198 2.256a752 752 0 0 0 2.78 2.813l.255.257z"
    />
  </svg>
);
export default SvgHeartOutline;
